import React from 'react';

const Logo = ({ size = 40, variant = 'light', className = '' }) => {
  const trunkColor = variant === 'light' ? '#1B6B4A' : 'rgba(255,255,255,0.7)';
  const childColor = variant === 'light' ? '#3BA676' : 'white';
  const childOpacity = variant === 'light' ? 1 : 0.9;
  const rootOpacity = variant === 'light' ? 0.25 : 0.2;

  return (
    <svg
      width={size}
      height={size * 1.1}
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M80 140 L80 95" stroke={trunkColor} strokeWidth="6" strokeLinecap="round" />
      <path d="M80 95 Q65 80, 50 65" stroke={trunkColor} strokeWidth="5" strokeLinecap="round" fill="none" />
      <path d="M80 95 Q95 80, 110 65" stroke={trunkColor} strokeWidth="5" strokeLinecap="round" fill="none" />
      <circle cx="44" cy="50" r="24" fill="#F5C842" opacity="0.85" />
      <circle cx="56" cy="42" r="18" fill="#F5C842" opacity="0.5" />
      <circle cx="116" cy="50" r="24" fill="#F2886D" opacity="0.85" />
      <circle cx="104" cy="42" r="18" fill="#F2886D" opacity="0.5" />
      <circle cx="80" cy="92" r="9" fill={childColor} opacity={childOpacity} />
      <path d="M80 140 Q70 148, 58 148" stroke={trunkColor} strokeWidth="3" strokeLinecap="round" fill="none" opacity={rootOpacity} />
      <path d="M80 140 Q90 148, 102 148" stroke={trunkColor} strokeWidth="3" strokeLinecap="round" fill="none" opacity={rootOpacity} />
    </svg>
  );
};

export default Logo;
